import { trackEvent } from "@src/utils/trackEvent"

export type LandingCtaLocation =
  | "hero"
  | "closing"
  | "header_create_account"
  | "header_sign_in"
  | "header_open_app"
  | "deals_widget"
  | "swap_widget"

export function trackLandingCta(location: LandingCtaLocation) {
  trackEvent("landing_cta_clicked", { location })
}
